/* 29.09.2026 (Joey-Loom, Philipp): Ausstattungs-Popup der Kaufbox B - Barrierefreiheit fuer das Blatt.
   Oeffnen/Schliessen, Preis und Auswahl bleiben in sections/edelholz-pdp-minikonfigurator.liquid (sheetSet).
   Hier nur: Fokus ins Popup, Fokus-Falle (Tab), Fokus zurueck auf die Ausstattungs-Zeile,
   und Esc schliesst bei offenem "Mehr erfahren"-Popup (eh-dpop) nur dieses, nicht beide. */
(function () {
  'use strict';
  var FOKUS = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function dpopOffen() { return !!document.querySelector('.eh-dpop.is-open'); }
  function sichtbar(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }

  function init(sheet) {
    if (sheet.__ehAus) return;
    sheet.__ehAus = true;
    var panel = sheet.querySelector('.eh-mk__sheet-panel');
    var ausz = document.querySelector('[data-mk-ausz][aria-controls="' + sheet.id + '"]');
    if (!panel) return;
    var zuvor = null;

    function fokusListe() {
      return Array.prototype.filter.call(panel.querySelectorAll(FOKUS), sichtbar);
    }

    function geoeffnet() {
      zuvor = document.activeElement;
      var x = panel.querySelector('.eh-mk__sheet-x');
      /* erst nach dem Paint fokussieren, sonst springt Safari beim display-Wechsel */
      requestAnimationFrame(function () {
        try { (x || panel).focus({ preventScroll: true }); } catch (e) { (x || panel).focus(); }
      });
    }
    function geschlossen() {
      var ziel = (zuvor && document.contains(zuvor) && zuvor !== document.body) ? zuvor : ausz;
      zuvor = null;
      if (ziel && typeof ziel.focus === 'function') {
        try { ziel.focus({ preventScroll: true }); } catch (e) { ziel.focus(); }
      }
    }

    new MutationObserver(function () {
      if (sheet.hidden) geschlossen(); else geoeffnet();
    }).observe(sheet, { attributes: true, attributeFilter: ['hidden'] });

    /* Fokus-Falle */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || sheet.hidden || dpopOffen()) return;
      var l = fokusListe();
      if (!l.length) { e.preventDefault(); panel.focus(); return; }
      var erst = l[0], letzt = l[l.length - 1], akt = document.activeElement;
      if (!panel.contains(akt)) { e.preventDefault(); (e.shiftKey ? letzt : erst).focus(); return; }
      if (e.shiftKey && (akt === erst || akt === panel)) { e.preventDefault(); letzt.focus(); }
      else if (!e.shiftKey && akt === letzt) { e.preventDefault(); erst.focus(); }
    });
  }

  /* Esc: liegt das "Mehr erfahren"-Popup ueber dem Blatt, schliesst Esc nur das Popup.
     Capture auf window laeuft vor den document-Listenern von Blatt und Popup. */
  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !dpopOffen()) return;
    var offen = document.querySelector('[data-mk-sheet]:not([hidden])');
    if (!offen) return;
    e.stopImmediatePropagation();
    if (window.EhDpop && typeof window.EhDpop.close === 'function') window.EhDpop.close();
  }, true);

  /* 09.10.2026 (Joey-Review 3, Vorschlag A): Zustand im Ausstattungs-Kasten.
     Die Section legt bei jedem renderAusz() { ad: [Add-on-Titel], preis: 'x €' oder '', rest: [Kabelfach, Durchlass] }
     an den Knopf (az.__eh) und ruft window.EhAusz(az). Ohne Auswahl: "Keine Zusatzausstattung" + Zeile Serie
     (Kabelfach, Durchlaesse). Mit Auswahl: nur Add-on-Namen + Aufpreis. Rechts bleibt "Anpassen". */
  window.EhAusz = function (az) {
    var d = az && az.__eh; if (!d) return;
    var strong = az.querySelector('.eh-mk__ausz-text strong'); if (!strong) return;
    var small = az.querySelector('[data-mk-ausz-text]');
    var ad = (d.ad || []).filter(Boolean);
    /* max. 2 Zeilen: mobil 1 Name, Desktop 3, der Rest als "und N weitere" (keine Ellipse) */
    var max = window.innerWidth < 750 ? 1 : 3;
    var namen = ad.length > max + 1 ? ad.slice(0, max).join(', ') + ' und ' + (ad.length - max) + ' weitere' : ad.join(', ');
    strong.textContent = ad.length ? namen : 'Keine Zusatzausstattung';
    if (ad.length && d.preis) {
      var p = document.createElement('span');
      p.className = 'eh-mk__ausz-preis';
      p.textContent = ' · + ' + d.preis;
      strong.appendChild(p);
    }
    /* v2 (Philipp 09.10.): mit Auswahl nur Add-ons + Aufpreis, die Kabelfach-Zeile entfaellt */
    if (small) { small.textContent = ad.length ? '' : (d.rest || []).join(' · '); small.hidden = !small.textContent; }
    az.setAttribute('aria-label', 'Ausstattung: ' + strong.textContent + (small && small.textContent ? ', ' + small.textContent : '') + '. Anpassen');
  };

  function start() {
    document.querySelectorAll('[data-mk-sheet]').forEach(init);
    document.querySelectorAll('[data-mk-ausz]').forEach(function (az) { try { window.EhAusz(az); } catch (e) {} });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
